import script from "./ClaimContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimContainer.vue?vue&type=script&setup=true&lang=js"

import "./ClaimContainer.vue?vue&type=style&index=0&id=33ec7bfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ec7bfc"]])

export default __exports__